import React from 'react'
import PageHeader from '../components/PageHeader';

export default function About() {
  const breadcrumbs = [
    { label: 'Home', link: '/' },
    { label: 'Pages', link: '/pages' },
    { label: 'About Us', active: true },
  ];
  return (
    <div>
      {/* Page Header Start */}
      <PageHeader title="About Us" breadcrumbs={breadcrumbs} />
      {/* Page Header End */}

      {/* About Start */}
      <div className="container-xxl py-5">
        <div className="container">
          <div className="row g-5">
            <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
              <div className="img-border">
                <img className="img-fluid" src="/assests/img/about.jpg" alt="" />
              </div>
            </div>
            <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.5s">
              <div className="h-100">
                <h6 className="section-title bg-white text-start text-primary pe-3">
                  About Us 
                </h6>
                <h1 className="display-6 mb-4">
                  बिहार   {" "}
                  <span className="text-primary"> बाल अधिकार </span>
                  संरक्षण आयोग
                </h1>
          <p className='text-justify'>
      देश में बाल अधिकार एवं संरक्षण से संबंधित कई कानून बने जिसमें समय-समय पर परिवर्तन भी किया जाता रहा। 2002 में संयुक्त राष्ट्र संघ की "बच्चों के लिए सुरक्षित दुनिया" पर हुआ समारोह इस दिशा में वैश्विक स्तर पर एक महत्वपूर्ण कदम माना जा सकता है। इसके प्रोटोकॉल पर भारत के हस्ताक्षर के बाद 2005 में बाल अधिकार संरक्षण आयोग बिल पेश हुआ जो 2006 में पारित होकर बाल अधिकार संरक्षण आयोग अधिनियम के रूप में परिवर्तित हो गया। इस अधिनियम के तहत 2007 में राष्ट्रीय स्तर पर "राष्ट्रीय बाल अधिकार संरक्षण आयोग" का गठन हुआ तथा इसी अधिनियम की धारा 17 के तहत सभी राज्यों में बाल अधिकार संरक्षण आयोग गठित करने की अधिसूचना जारी हुई। इस आलोक में 30 अगस्त 2010 को बिहार राज्य बाल अधिकार संरक्षण आयोग के गठन की अधिसूचना जारी की गयी।
    </p>
    <p className="mb-4">
      आयोग का मुख्य कर्तव्य बाल अधिकार पर हुए अंतर्राष्ट्रीय कन्वेंशन के अनुपालन के आलोक में देश में विद्यमान कानूनी नीतियों और प्रचलित प्रथाओं का बाल अधिकार के दृष्टिकोण से विश्लेषण करना है, साथ ही बाल अधिकारों के हनन करने वाले प्रथाओं अथवा नीतियों की जाँच पड़ताल कर त्वरित कार्रवाई के लिए सरकार को मंतव्य देना, बाल अधिकारों के परिप्रेक्ष्य में प्रस्तावित नये कानूनों पर मंतव्य देना अथवा पुराने कानूनों में संशोधन की अनुशंसा करना भी आयोग की जिम्मेदारी है।
      बाल अधिकारों के संबंध में आयोग को यह जिम्मेदारी प्रदान की गई कि वह राष्ट्रीय आयोग के साथ समन्वय स्थापित करे, बाल अधिकारों के उल्लंघन कार्यों की जाँच पड़ताल करे, बच्चों से संबंधित सरकार, किसी अन्य अधीनस्थ प्राधिकार अथवा संगठन से निर्धारित समय सीमा के अंदर आवश्यक सूचनाओं या प्रतिवेदन की मांग करे, बच्चों से संबंधित आंकड़े संकलित कर उनका विश्लेषण करे, बाल अधिकारों के बारे में जानकारी विकसित करे तथा उनका प्रचार-प्रसार करे।
    </p>
                {/* <div class="d-flex align-items-center mb-4 pb-2">
                      <img class="flex-shrink-0 rounded-circle" src="/assests/img/team-1.jpg" alt=""
                          style="width: 50px; height: 50px;">
                      <div class="ps-4">
                          <h6>Jhon Doe</h6>
                          <small>SEO & Founder</small>
                      </div>
                  </div> */}
                {/* <a className="btn btn-primary rounded-pill py-3 px-5" href="">
                  Read More
                </a> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* About End */}
    </div>
  )
}
